import React, { useContext, useEffect, useState, useRef } from "react";
import { Button, Col, Row } from "antd";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { AiOutlineEdit, AiOutlinePlusCircle } from "react-icons/ai";
import { FaArrowLeft, FaCopy } from 'react-icons/fa';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";

const ClienteMaquinas = (props) => {

  const styles = `
  .Maquinas-page {
    background-color: black;
    color: white;
    margin: 0;
    padding: 0;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;     
  }
.Cliente_atualizar {
  display: flex;
  justify-content: center; /
  align-items: center; 
  width: 100%;
}
.button-container {
  display: flex;
  justify-content: center; 
  flex-wrap: wrap; 
  gap: 15px; 
  width: 100%;
  gap: 60px;
}
.button-container button {
  margin: 0; 
}

  .Maquinas-page .Cliente_atualizar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 20px;
    gap: 15px;
    padding-bottom: 25px;
  }
  .Cliente_title {
    font-family: 'Arial', sans-serif;
    font-size: 30px; 
    font-weight: bold; 
    color: #c8dd06; 
    margin-bottom: 25px;
    padding: 0;
    display: flex;
    justify-content: center; 
    line-height: 1;
  }

  .Botao-Voltar,
  .Botao-Ids,
  .Botao-Atualizar,
  .Botao-Editar,
  .Botao-Adicionar {
    font-size: 20px;
    padding: 20px;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    color: white;
    margin: 0 20px;
    transition: all 0.3s ease;
    cursor: pointer;
    border: 1px solid #ffffff;
  }
   
  .Botao-Adicionar { background-color:rgb(27, 151, 3); }
  .Botao-Editar { background-color: #e0a800; }
  .Botao-Atualizar { background-color:rgb(4, 8, 247); }
  .Botao-Voltar{ background-color: rgb(163, 3, 163);}
  .Botao-Ids{ background-color:rgb(163, 80, 3);}

  .Botao-Adicionar:hover { background-color:rgb(89, 253, 116);}
  .Botao-Editar:hover { background-color:rgb(248, 214, 112);}
  .Botao-Atualizar:hover { background-color:rgb(103, 105, 255);}
  .Botao-Voltar:hover { background-color: rgb(250, 31, 250); }
  .Botao-Ids:hover { background-color:rgb(252, 166, 86);}

  .Maquinas-page .buttons button i {
    margin-right: 5px;
  }
  .machines {
    flex: 1 1 calc(25% - 10px); 
    max-width: calc(25% - 10px); 
    display: flex;
    flex-direction: column;
    margin: 5px; 
    transition: all 0.3s ease; 
  }
  .maquina {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 2px solid #ffffff;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  min-width: 150px;
  flex-grow: 1;
  color: #000000;
  transition: transform 0.2s ease, height 0.3s ease;
  overflow: hidden;
  max-height: 110px;
  word-wrap: break-word;
  white-space: pre-wrap;
  }
 .maquina.expanded {
  font-family: 'Liberation Mono', monospace; 
  max-height: 500px;
  flex: 1 1 100%;
  }
 .maquina h2.nome {
  font-size: 34px;
  font-family: 'arial';
  margin-bottom: 1px; /* Reduz o espaço abaixo do nome */
  line-height: 1.2; /* Ajusta a altura da linha do nome */
 }
 .maquina h4.descricao {
  font-size: 30px;
  font-family: 'arial';
  margin-top: 1px; /* Reduz o espaço acima da descrição */
  line-height: 1.2; /* Ajusta a altura da linha da descrição */
  }
  .no-machines {
    margin-left: 30px;
    font-size: 30px;
    color: white;
    text-align: center;
  }
  .botao {
  width: 100%; 
  padding: 10px 5px;
  text-align: center;
  min-height: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 20px;
  }
  
  @media only screen and (max-width: 1020px) and (orientation: landscape) {
  .machines {
    flex: 1 1 calc(50% - 10px);
    max-width: calc(50% - 10px);
  }

  .button-container {
    display: flex;
    flex-wrap: wrap; /* Permite que os botões quebrem para a próxima linha */
    gap: 25px; /* Espaçamento entre os botões */
    padding: 0; /* Remove o padding lateral */
    width: 100%; /* Garante que o contêiner ocupe toda a largura da tela */
  }

  .button-container button {
    width: calc(33.33% - 17px); /* 3 botões por linha com espaçamento */
    padding: 20px; /* Altura dos botões */
    font-size: 26px; /* Tamanho da fonte */
    box-sizing: border-box; /* Garante que o padding não aumente a largura */
    align-items: center;
    justify-content: center;
    border-radius: 8px; /* Bordas arredondadas */
    text-transform: uppercase; /* Texto em maiúsculas */
  }
  .button-container button.Botao-Voltar:last-child {
    width: calc(66.66% - 12.5px); /* Ocupa o espaço de 2 botões */
    margin-left: auto; /* Centraliza o botão */
    margin-right: auto; /* Centraliza o botão */
  }
}

@media only screen and (max-width: 760px) and (orientation: portrait) {
  .machines {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .Cliente_title {
    margin-left: 0;
    text-align: center;
    width: 100%;
  }

  .button-container {
    display: flex;
    flex-direction: column; /* Coloca os botões em uma coluna */
    gap: 20px; /* Espaçamento entre os botões */
    padding: 0; /* Remove o padding lateral */
    width: 100%; /* Garante que o contêiner ocupe toda a largura da tela */
  }

  .button-container button {
    width: 100%; /* Ocupa toda a largura da linha */
    margin: 0; /* Remove margens laterais */
    padding: 20px; /* Altura dos botões */
    font-size: 26px; /* Tamanho da fonte */
    box-sizing: border-box; /* Garante que o padding não aumente a largura */
    align-items: center;
    justify-content: center;
    border-radius: 8px; /* Bordas arredondadas */
    text-transform: uppercase; /* Texto em maiúsculas */
  }
    
  .Botao-Voltar,
  .Botao-Ids,
  .Botao-Atualizar,
  .Botao-Editar,
  .Botao-Adicionar {
    min-height: 60px;
  }
   
}

}

  `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;

  const location = useLocation();
  let navigate = useNavigate();
  const clienteInfo = location.state;
  const token = authInfo?.dataUser?.token;
  const { id } = useParams();

  const [totalClienteMaquinas, setTotalClienteMaquinas] = useState([]);
  const [expandedLine, setExpandedLine] = useState(null); // Linha atualmente expandida

  // Referências para os elementos das máquinas
  const maquinaRefs = useRef([]);

  // Função para expandir/retrair uma linha
  const toggleExpandLine = (lineIndex) => {
    if (expandedLine === lineIndex) {
      setExpandedLine(null); // Retrai a linha se já estiver expandida
    } else {
      setExpandedLine(lineIndex); // Expande a linha
    }
  };

  const handleMachineClick = (lineIndex, post) => {
    const maquinaElement = maquinaRefs.current[post.id];
    if (maquinaElement) {
      const isOverflowing = maquinaElement.scrollHeight > maquinaElement.clientHeight;
      const heightDifference = maquinaElement.scrollHeight - maquinaElement.clientHeight;
      if (isOverflowing && heightDifference > 20) { // Ajuste o valor 20 conforme necessário
        toggleExpandLine(lineIndex);
      } else {
        navigate(`/cliente-maquinas/pagamentos/${post.id}`, {
          state: { clienteInfo, maquinaInfos: post },
        });
      }
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        setNotiMessage({
          type: "success",
          message: "As Id's foram copiadas para área de transferência.",
        });
      },
      (err) => {
        setNotiMessage({
          type: "error",
          message: "Erro ao copiar Id's para área de transferência.",
        });
      }
    );
  };

  const handleMachinesData = () => {
    const maquinasInfo = totalClienteMaquinas.map(
      (post) => `Máquina: ${post.nome}, ID: ${post.id}`
    );
    const maquinasText = maquinasInfo.join("\n");
    //  console.log("Informações das Máquinas:", maquinasText);
    copyToClipboard(maquinasText);
  };

  useEffect(() => {
    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line
  }, []);

  const dataData = () => {
    axios
      .get(`${process.env.REACT_APP_SERVIDOR}/maquinas-adm?id=${id}`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setTotalClienteMaquinas(res.data);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message: "Sua sessão expirou, faça login novamente. 04",
          });
          setDataUser(null);
        }
      });
  };

  //  Agrupa as máquinas em linhas de 4
  const groupMachinesIntoLines = (machines, machinesPerLine = 4) => {
    const lines = [];
    for (let i = 0; i < machines.length; i += machinesPerLine) {
      lines.push(machines.slice(i, i + machinesPerLine));
    }
    return lines;
  };

  const machineLines = groupMachinesIntoLines(totalClienteMaquinas);

  return (
    <div className="Maquinas-page">
      <div className="WarningMsgSpan">
        <span>{dataUser.warningMsg}</span>
      </div>

      <div className="Cliente_title">
        MÁQUINAS DO CLIENTE: {clienteInfo?.nome || "Cliente Selecionado"}
      </div>

      <div className="Cliente_atualizar">
      <div className="button-container">
        <Button className="Botao-Adicionar"
          onClick={() =>
            navigate(`/cliente-maquinas/adicionar-maquina-adm/${clienteInfo.id}`, {
              state: location.state,
            })
          }
        >
          <AiOutlinePlusCircle />
          <span>ADD MÁQUINA</span>
        </Button>

        <Button className="Botao-Editar"
          onClick={() =>
            navigate(`/editar-cliente/${clienteInfo.id}`, {
              state: location.state,
            })
          }
        >
          <span>EDITAR CLIENTE</span>
        </Button>

        <Button
          className="Botao-Atualizar"
          onClick={() => window.location.reload()}
        >
          <FontAwesomeIcon icon={faArrowsRotate} />
          ATUALIZAR
        </Button>

        <Button className="Botao-Ids" onClick={handleMachinesData}>
          <FaCopy />
          COPIAR IDs
        </Button>

        <Button className="Botao-Voltar" onClick={() => navigate("/dashboard-clientes")} >
          <FaArrowLeft />
          VOLTAR
        </Button>
      </div>
      </div>
      <Row>
        {machineLines.map((line, lineIndex) => (
          <React.Fragment key={lineIndex}>
            {line.map((post) => {
              const backgroundColor =
                post.status.toLowerCase() === "online"
                  ? "linear-gradient(to bottom, #50ca1b 60%, #a8e063 100%)"
                  : post.status.toLowerCase() === "offline"
                    ? "linear-gradient(to bottom, #ff0000 60%, #ff6666 100%)"
                    : post.status.toLowerCase() === "pagamento_recente"
                    ? "linear-gradient(to bottom,rgb(6, 132, 250) 60%,rgb(57, 190, 252) 100%)"
                      : "rgb(250, 172, 4)";

              return (
                <Col className="machines" key={post.id}>
                  <div
                    ref={(el) => (maquinaRefs.current[post.id] = el)}
                    className={`maquina ${expandedLine === lineIndex ? "expanded" : ""}`}
                    style={{
                      background: backgroundColor,
                    }}
                    onClick={() => handleMachineClick(lineIndex, post)}
                  >
                    <h2 className="nome">{post.nome}</h2>
                    <h4 className="descricao">{post.descricao}</h4>
                  </div>
                </Col>
              );
            })}
          </React.Fragment>
        ))}
        {totalClienteMaquinas.length === 0 && (
          <div className="no-machines">Nenhuma máquina encontrada</div>
        )}
      </Row>
    </div>
  );
};

export default ClienteMaquinas;